import axiosInstance from '../../api/axios';

/** GET `/api/sox-controls/lists` — raw response; map in `functional.js`. */
export async function getSoxControlsListPage({ page, pageSize = 20, search = '', classification = 'business' }) {
  const requestedPageSize = Math.max(1, Number(pageSize) || 20);
  const requestedPage = Math.max(1, Number(page) || 1);
  const resolvedClassification = String(classification ?? '').trim() || 'business';

  const response = await axiosInstance.get('/api/sox-controls/lists', {
    params: {
      page: requestedPage,
      page_size: requestedPageSize,
      classification: resolvedClassification,
      ...(search?.trim() ? { search: search.trim() } : {}),
    },
  });

  return response.data;
}
